import { Injectable } from '@angular/core';

export enum GainsightEvent {
    StartRecordAnimation = 'Start record animation',
    StopRecordAnimation = 'Stop record animation',
    ApplyCharacterStyling = 'Apply character styling',
    ClearCharacterStyling = 'Clear character styling'
}

/**
 * GainsightService is used for sending custom events.
 * Note: Google Tag Manager injects the script and it is available in sandbox/production
 *
 * https://support.gainsight.com/PX/API_for_Developers/02Usage_of_Different_APIs/Use_Custom_Event_API
 */
@Injectable({ providedIn: 'root' })
export class GainsightService {
    public sendCustomEvent(event: GainsightEvent, properties?: any): void {
        if (window['aptrinsic']) {
            (window as any).aptrinsic('track', event, properties);
        }
    }
}
